module.exports = __webpack_public_path__ + "img/21.7.Chla.aa21a053.png";